import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Barometro from "@/pages/Barometro";
import Incidents from "@/pages/Incidents";
import Import from "@/pages/Import";
import QualityRoutes from "@/pages/QualityRoutes";
import FieldRoute from "@/pages/FieldRoute";
import Admin from "@/pages/Admin";
import Reports from "@/pages/Reports";
import Asistente from "@/pages/Asistente";
import MapaEnVivo from "@/pages/MapaEnVivo";

function Home() {
  const { user } = useAuth();
  if (!user) return null;
  return <Navigate to={user.role === "encargado" ? "/mi-ruta" : "/dashboard"} replace />;
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster position="top-right" />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Home />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute roles={["admin", "jefe_servicio", "oficina", "lectura"]}>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/barometro"
                element={
                  <ProtectedRoute roles={["admin", "jefe_servicio", "oficina", "lectura"]}>
                    <Barometro />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/incidencias"
                element={
                  <ProtectedRoute roles={["admin", "jefe_servicio", "oficina", "lectura"]}>
                    <Incidents />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/importar"
                element={
                  <ProtectedRoute roles={["admin", "jefe_servicio", "oficina"]}>
                    <Import />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/rutas"
                element={
                  <ProtectedRoute roles={["admin", "jefe_servicio", "oficina", "lectura"]}>
                    <QualityRoutes />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/mi-ruta"
                element={
                  <ProtectedRoute roles={["encargado"]}>
                    <FieldRoute />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/informes"
                element={
                  <ProtectedRoute roles={["admin", "jefe_servicio", "oficina"]}>
                    <Reports />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/asistente"
                element={
                  <ProtectedRoute roles={["admin", "jefe_servicio", "oficina"]}>
                    <Asistente />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/mapa-en-vivo"
                element={
                  <ProtectedRoute roles={["admin", "jefe_servicio", "oficina"]}>
                    <MapaEnVivo />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/administracion"
                element={
                  <ProtectedRoute roles={["admin", "jefe_servicio"]}>
                    <Admin />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
